<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      title="Məhsullar və Xidmətlərim"
      :main="$t('dashboardVue.dashboard')"
    />
    <div
      class="container mt-4"
      style="max-width: 1800px"
    >
      <div class="row">
        <div class="col-xl-9">
          <div class="d-flex justify-content-start mb-3 ml-4">
            <button
              class="btn btn-outline-primary btn-lg"
              @click.prevent="$router.push({ name: 'newProductOrServicePage' })"
            >
              + Yeni məhsul və xidmət yarat
            </button>
          </div>

          <div class="card">
            <div class="card-header text-center">
              <h3>Filter</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <select
                    v-model="filters.type.selectedType"
                    class="form-control"
                  >
                    <option value="">
                      Məhsullar və Xidmətlər
                    </option>
                    <option value="PRODUCT">
                      Məhsullar
                    </option>
                    <option value="SERVICE">
                      Xidmətlər
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <select
                    v-model="filters.status.selectedStatus"
                    class="form-control"
                  >
                    <option value="">
                      Status
                    </option>
                    <option value="DRAFT">
                      Qaralamada olanlar (DRAFT)
                    </option>
                    <option value="ACTIVE">
                      Təsdiqlənib paylaşılanlar (ACTIVE)
                    </option>
                    <option value="WAITING">
                      Təsdiq gözləyənlər (WAITING)
                    </option>
                    <option value="RETURNED">
                      Geri qaytarılanlar (RETURNED)
                    </option>
                    <option value="REJECTED">
                      Rədd edilənlər (REJECTED)
                    </option>
                    <option value="HAD_ADVERTISEMENT">
                      Reklam edilənlər (HAD_ADVERTISEMENT)
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              v-for="product in filteredProducts"
              :key="product.id"
              class="col-md-3 col-lg-3 mb-4 d-flex align-items-stretch"
            >
              <div
                class="custom-card w-100"
                @click.prevent="$router.push({ name: 'product', params: { id: product.id } })"
              >
                <div class="custom-card-body text-center d-flex flex-column justify-content-between">
                  <div
                    v-if="product.status === 'ACTIVE'"
                    class="active-indicator"
                  />
                  <img
                    :src="mediaBase + product.coverPhotoUrl"
                    class="img-fluid mb-3 custom-product-image"
                    alt="Product"
                  >
                  <div class="custom-product-title mb-2">
                    <h5>{{ product.name }}</h5>
                  </div>
                  <div class="custom-company-name">
                    {{ product.company.name }}
                  </div>
                  <div
                    v-if="product.hasActiveAdvertisement"
                    class="advertisement-indicator"
                  >
                    Advertisement Active
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center mt-4">
            <button
              class="btn btn-primary"
              @click.prevent="$router.push({ name: 'myAllProductsPage' })"
            >
              Bütün məhsulları gör
            </button>
          </div>

          <div class="alert alert-warning mt-4">
            <h5>Şirkət profili məlumatları</h5>
            <p>
              Şirkət haqqında məlumatlarınızı yeniləməyiniz tövsiyə edilir. Məhsul seçərkən satnalmaçılar müəyyən
              kriteriyalar üzrə axtarış verə bilərlər. Həmin axtarış kriteriyalarında şirkətinizin məhsul və
              xidmətlərinin çıxması üçün bu məlumatların doldurulması tövsiyə edilir.
            </p>
          </div>
        </div>

        <div class="col-xl-3">
          <div class="card mb-4 tariff-card">
            <div class=" card-body text-center">
              <h5>Sizin tarifiniz</h5>
              <span class="badge badge-success tariff-badge">{{ userPackage.pack.name }}</span>
              <button
                class="btn btn-primary tariff-btn"
                @click.prevent="$router.push({ name: 'subscriptionPage' })"
              >
                Tarifi dəyiş
              </button>
              <p class="tariff-info">
                Məhsul və xidmət paylaşım limiti və reklam paylaşım limiti paket tarifinə görə müəyyənləşdirilmişdir
              </p>
            </div>
          </div>
          <div class="youtube-icon-container text-center mt-3">
            <a
              href="https://youtu.be/jR8oEhRcGlc"
              target="_blank"
              class="youtube-icon"
              title="İstifadəçi təlimatı"
            >
              <i class="fa fa-youtube fa-3x" />
            </a>
            <p class="mt-2">
              İstifadəçi üçün təlimat
            </p>
          </div>
        </div>

        <div class="col-xl-12 mt-4">
          <ul
            id="myTab"
            class="nav nav-tabs"
            role="tablist"
          >
            <li
              class="nav-item"
              role="presentation"
            >
              <a
                id="distributor-tab"
                class="nav-link"
                :class="{ active: activeTab === 'distributor' }"
                role="tab"
                aria-controls="distributor"
                aria-selected="activeTab === 'distributor'"
                @click="activeTab = 'distributor'"
              >
                Distribyutorluq sənədləri
              </a>
            </li>
            <li
              class="nav-item"
              role="presentation"
            >
              <a
                id="certificates-tab"
                class="nav-link"
                :class="{ active: activeTab === 'certificates' }"
                role="tab"
                aria-controls="certificates"
                aria-selected="activeTab === 'certificates'"
                @click="activeTab = 'certificates'"
              >
                Sertifikat və lisenziyalar
              </a>
            </li>
            <li
              class="nav-item"
              role="presentation"
            >
              <a
                id="contracts-tab"
                class="nav-link"
                :class="{ active: activeTab === 'contracts' }"
                role="tab"
                aria-controls="contracts"
                aria-selected="activeTab === 'contracts'"
                @click="activeTab = 'contracts'"
              >
                Oxşar işlərlə bağlı müqavilə və referanslar
              </a>
            </li>
          </ul>
          <div
            id="myTabContent"
            class="tab-content mt-3"
          >
            <div
              id="distributor"
              class="tab-pane fade"
              :class="{ show: activeTab === 'distributor', active: activeTab === 'distributor' }"
              role="tabpanel"
              aria-labelledby="distributor-tab"
            >
              <div v-if="documents.distributor.length === 0">
                <p>No documents available.</p>
              </div>
              <div
                v-for="(doc) in documents.distributor"
                :key="doc"
                class="col-md-3 mb-3"
              >
                <div
                  class="card position-relative"
                  style="margin-bottom: 0"
                >
                  <a
                    target="_blank"
                    :href="mediaBase + doc"
                    class="card h-100 border border-dark text-center"
                  >
                    <div class="card-body d-flex justify-content-center align-items-center">
                      {{ doc.split('/').pop() }}
                    </div>
                  </a>
                  <div
                    class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                    style="cursor: pointer;"
                  >
                    <feather
                      type="trash"
                      @click="deleteDocument('distributor', doc)"
                    />
                  </div>
                </div>
              </div>
              <button
                class="btn btn-primary"
                @click="triggerFileInput('distributorFile')"
              >
                Upload File
              </button>
              <input
                ref="distributorFile"
                type="file"
                class="d-none"
                @change="uploadDocument('distributor')"
              >
            </div>
            <div
              id="certificates"
              class="tab-pane fade"
              :class="{ show: activeTab === 'certificates', active: activeTab === 'certificates' }"
              role="tabpanel"
              aria-labelledby="certificates-tab"
            >
              <div v-if="documents.certificates.length === 0">
                <p>No documents available.</p>
              </div>
              <div
                v-for="(doc, index) in documents.certificates"
                :key="index"
                class="col-md-3 mb-3"
              >
                <div
                  class="card position-relative"
                  style="margin-bottom: 0"
                >
                  <a
                    target="_blank"
                    :href="mediaBase + doc"
                    class="card h-100 border border-dark text-center"
                  >
                    <div class="card-body d-flex justify-content-center align-items-center">
                      {{ doc.split('/').pop() }}
                    </div>
                  </a>
                  <div
                    class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                    style="cursor: pointer;"
                  >
                    <feather
                      type="trash"
                      @click="deleteDocument('certificates', doc)"
                    />
                  </div>
                </div>
              </div>
              <button
                class="btn btn-primary"
                @click="triggerFileInput('certificatesFile')"
              >
                Upload File
              </button>
              <input
                ref="certificatesFile"
                type="file"
                class="d-none"
                @change="uploadDocument('certificates')"
              >
            </div>
            <div
              id="contracts"
              class="tab-pane fade"
              :class="{ show: activeTab === 'contracts', active: activeTab === 'contracts' }"
              role="tabpanel"
              aria-labelledby="contracts-tab"
            >
              <div v-if="documents.contracts.length === 0">
                <p>No documents available.</p>
              </div>
              <div
                v-for="(doc, index) in documents.contracts"
                :key="index"
                class="col-md-3 mb-3"
              >
                <div class="card position-relative">
                  <a
                    target="_blank"
                    :href="mediaBase + doc"
                    class="card h-100 border border-dark text-center"
                  >
                    <div class="card-body d-flex justify-content-center align-items-center">
                      {{ doc.split('/').pop() }}
                    </div>
                  </a>
                  <div
                    class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                    style="cursor: pointer;"
                  >
                    <feather
                      type="trash"
                      @click="deleteDocument('contracts', doc)"
                    />
                  </div>
                </div>
              </div>
              <button
                class="btn btn-primary"
                @click="triggerFileInput('contractsFile')"
              >
                Upload File
              </button>
              <input
                ref="contractsFile"
                type="file"
                class="d-none"
                @change="uploadDocument('contracts')"
              >
            </div>
          </div>
        </div>
        <div class="col-xl-7 mt-3">
          <div
            id="targetProductInquiry"
            class="card"
          >
            <div class="card-body">
              <h3>Məhsul və xidmət haqqında sorğular</h3>
              <ul class="list-group">
                <li
                  v-for="(inquiry, index) in displayedInquiries"
                  :key="index"
                  class="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div>
                    <img
                      :src="mediaBase + inquiry.coverPhotoUrl"
                      class="img-thumbnail mr-2"
                      alt="Product Image"
                      style="width: 50px; height: 50px;"
                    >
                    <strong>{{ inquiry.productName }}</strong>
                    <p class="mb-1">
                      {{ inquiry.inquiryText }}
                    </p>
                    <p class="mb-1">
                      {{ inquiry.userName + ' ' + inquiry.userSurname }}
                    </p>
                    <small>{{ inquiry.inquiryTime }}</small>
                  </div>
                  <button
                    :class="['btn btn-sm', inquiry.conversationId > 0 ? 'btn-success' : 'btn-primary']"
                    @click="startConversation(inquiry)"
                  >
                    {{ inquiry.conversationId > 0 ? 'Müzakirəyə Davam et' : 'Müzakirəyə başla' }}
                  </button>
                </li>
              </ul>
              <button
                v-if="!showAllInquiries"
                class="btn btn-primary mt-3"
                @click="showAllInquiries = true"
              >
                Show All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {addDocument, deleteDocument, getCompanyDocuments, getProducts} from "@/repositories/ProductDataRepository";
import {upload} from "@/repositories/GeneralDataRepository";
import {getInquiriesForCompany} from "@/repositories/InquiryDataRepository";
import {startConversation} from "@/repositories/ProductConversationDataRepository";

export default {
  data() {
    return {
      mediaBase: mediaBase,
      products: [],
      activeTab: 'distributor',
      documents: {
        distributor: [],
        certificates: [],
        contracts: []
      },
      inquiries: [],
      showAllInquiries: false,
      uploadProgress: 0,
      filters: {
        status: {
          selectedStatus: ''
        },
        type: {
          selectedType: ''
        }
      }
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
      company: (state) => state.auth.company,
      sessionType: (state) => state.auth.sessionType,
      profile: (state) => state.auth.profile,
      position: (state) => state.auth.position,
      userPackageStatus: (state) => state.auth.userPackageStatus,
      userPackage: (state) => state.auth.userPackage,
    }),
    displayedInquiries() {
      return this.showAllInquiries ? this.inquiries : this.inquiries.slice(0, 10);
    },
    filteredProducts() {
      return this.products.filter(product => {
        const matchesType = !this.filters.type.selectedType || product.type === this.filters.type.selectedType;
        const matchesStatus = !this.filters.status.selectedStatus ||
            product.status === this.filters.status.selectedStatus ||
            (this.filters.status.selectedStatus === 'HAD_ADVERTISEMENT' && product.hasHadAdvertisement);
        return matchesType && matchesStatus;
      });
    }
  },
  mounted() {
    this.getProducts();
    this.getDocuments();
    this.getInquiries();
  },
  methods: {
    getProducts() {
      getProducts(this.token).then(data => {
        if (data.code === 200) {
          console.log(data)
          this.products = data.products;
        }
      });
    },
    getDocuments() {
      getCompanyDocuments(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          this.documents.distributor = data.companyDocumentsDto.distributionDocuments || [];
          this.documents.certificates = data.companyDocumentsDto.certificatesAndLicenses || [];
          this.documents.contracts = data.companyDocumentsDto.contractsAndReferencesForSimilarWorks || [];
        }
      });
    },
    uploadDocument(type) {
      let fileInput;
      if (type === 'distributor') {
        fileInput = this.$refs.distributorFile;
      } else if (type === 'certificates') {
        fileInput = this.$refs.certificatesFile;
      } else if (type === 'contracts') {
        fileInput = this.$refs.contractsFile;
      }
      let currentFile = fileInput.files[0];
      if (currentFile) {
        upload(this.token, type, currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        }, true)
            .then(response => {
              console.log(response)
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                const url = response.data.path;
                addDocument(this.token, type, url, this.company.id).then(data => {
                  if (data.code === 200) {
                    this.documents[type].push(url);
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error',
                    });
                  }
                });
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch(e => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      }
    },
    deleteDocument(type, doc) {
      deleteDocument(this.token, type, doc, this.company.id).then(data => {
        if (data.code === 200) {
          const index = this.documents[type].indexOf(doc);
          if (index > -1) {
            this.documents[type].splice(index, 1);
          }
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          });
        }
      });
    },
    triggerFileInput(refName) {
      this.$refs[refName].click();
    },
    getInquiries() {
      getInquiriesForCompany(this.token).then(data => {
        if (data) {
          this.inquiries = data;
        }
      });
    },
    startConversation(inquiry) {
      try {
        startConversation(this.token, inquiry.id).then(data => {
          if (data.code === 200) {
            const conversationId = data.id;
            console.log(data);
            this.$router.push({
              name: 'conversation',
              params: {id: conversationId},
              query: {conversation_type: "product"}
            });
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            });
          }
        });
      } catch (error) {
        this.$swal({
          title: 'Error',
          text: error.message,
          icon: 'error'
        });
      }
    }
  }
};
</script>


<style scoped>
.custom-card {
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  overflow: hidden;
  transition: box-shadow 0.3s ease-in-out;
  cursor: pointer;
}

.custom-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.custom-card-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 100%;
}

.custom-product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-bottom: 1px solid #ddd;
  margin-bottom: 16px;
}

.custom-product-title {
  font-size: 18px;
  margin-bottom: 10px;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.custom-company-name {
  font-size: 14px;
  color: #6c757d;
}

.btn-lg {
  padding: 1rem 2rem;
  font-size: 1.25rem;
}

.d-none {
  display: none;
}

.tariff-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.tariff-card h5 {
  margin-bottom: 20px;
}

.tariff-badge {
  display: block;
  width: 100%;
  padding: 10px 0;
  font-size: 18px;
  margin-bottom: 20px;
}

.tariff-btn {
  display: block;
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  margin-bottom: 20px;
}

.tariff-info {
  font-size: 14px;
  color: #6c757d;
  text-align: center;
}

.advertisement-indicator {
  background-color: #ffc107;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: bold;
  font-size: 0.9em;
  text-align: center;
}

.active-indicator {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  background-color: #28a745;
  border-radius: 50%;
  z-index: 1;
}
.youtube-icon-container {
  margin-top: 20px;
}

.youtube-icon {
  color: #FF0000;
  text-decoration: none;
}

.youtube-icon:hover {
  color: #CC0000;
}
</style>

